// extracted by mini-css-extract-plugin
export default {"my_btn":"CustomBtnPink_my_btn__m0R9p"};